<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-user-groups-getgroup" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header" *ngIf="allAgents">{{ 'realtime:usergroups_allAgents' | i18next }}</span>
    <span class="page-header" *ngIf="!allAgents">{{ "ticker:usergroups_usersInGroupHeader" | i18next }} {{groupName}}</span>
    <div class="right">
      <app-filter-input id="filter-input-user-groups-getgroup" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
    </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table  [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

       <ng-container matColumnDef="formattedName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:agent' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="link-buttons-cell">
          <a id="agent-details-btn-{{element.userId}}-user-groups-getgroup" [routerLink]="['/real-time/ticker-agents/details', element.userId]" [matTooltip]="'realtime:statusdetails_tooltip_details' | i18next" matTooltipClass="tooltip-font-14" [queryParams]="{ groupName: groupName, type: type }">{{ element.formattedName }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_details_phone_number' | i18next }}</th>
        <td mat-cell *matCellDef="let element">{{ element.phoneNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="profileName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_details_profile' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="link-buttons-cell">
        <ng-container *ngIf="!element.profileName">-</ng-container>
         <button id="profile-btn-{{element.userId}}-user-groups-getgroup" (click)="openProfile(element)" *ngIf="element.profileName" [matTooltip]="'realtime:statusdetails_tooltip_profile' | i18next" matTooltipClass="tooltip-font-14">{{ element.profileName }}</button>
        </td>
      </ng-container>
      <ng-container matColumnDef="formattedStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_details_status' | i18next }}</th>
        <td mat-cell *matCellDef="let element">
          <i class="fas fa-circle status-color" [style.color]="element.statusColor"></i>
          <!-- <img src="{{ element.statusIcon }}" alt="{{ element.formattedStatus }}" /> -->
          {{ element.formattedStatus }}
        </td>
      </ng-container>
      <ng-container matColumnDef="secondsInStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="'realtime:shared_tooltip_sort' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_details_timeInStatus' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="text-right">{{ element.formattedSecondsInStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="changeStatus">
        <th mat-header-cell *matHeaderCellDef  >{{ 'realtime:usergroups_details_changeStatus' | i18next }}</th>
        <td mat-cell *matCellDef="let element" class="link-buttons-cell">
          <button id="logoff-btn-{{element.userId}}-user-groups-getgroup" (click)="openChangeStatusDialog(element,'logOff')" *ngIf="element.statusLinkList?.length == 0" [matTooltip]="'realtime:statusdetails_tooltip_logOff' | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_lang_logOff' | i18next }}</button>
          <ng-container *ngFor="let status of element.statusLinkList; let last = last">
             <button id="status-btn-{{element.userId}}-{{status}}-user-groups-getgroup" (click)="openChangeStatusDialog(element,status)" [matTooltip]="'realtime:statusdetails_tooltip_' + status | i18next" matTooltipClass="tooltip-font-14">{{ 'realtime:usergroups_lang_'+status | i18next }}</button>

            <span *ngIf="!last">| </span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;trackBy: trackById"></tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

    </table>
  </div>
</div>
